import ellipsefooter1 from '@/assets/images/ellipse-footer-1.png'
import ellipsefooter2 from '@/assets/images/ellipse-footer-2.png'
import logoBrand from '@/assets/images/logo_lumar_footer.svg'
import { Logo } from '@/components/molecules/Logo/Logo'
import React from 'react'

interface FooterProps {
  isError?: boolean
}

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className='bg-white text-[#000000] p-2 lg:p-8 relative pt-[2rem] pb-[4rem] lg:pt-[4rem] overflow-hidden min-h-[300px]'>
      <img src={ellipsefooter1} alt='Ellipse Footer' className='absolute w-full h-full top-[1rem] left-0' />
      <img src={ellipsefooter2} alt='Ellipse Footer 2' className='absolute w-full h-full bottom-0 right-0' />
      <div className='container lg:max-w-[1380px] mx-auto flex flex-col md:flex-row justify-between items-start gap-8 relative z-10'>
        <div className='w-full md:w-auto h-full flex flex-col items-start justify-start flex-1 gap-4'>
          <Logo src={logoBrand} alt='Lumar Prestige Logo' width={173} height={56} />
        </div>
        <div className='flex flex-col md:flex-row gap-[2rem] w-full md:w-auto'>
          <div className='max-w-full md:max-w-[130px]'>
            <p className='text-[16px] font-semibold mb-[1rem]'>
              Legal & Compliance
            </p>
            <ul className='space-y-2 opacity-[.40] text-[#000000]'>
              <li>
                Terms and Conditions
              </li>
            </ul>
          </div>
          <div className='max-w-full md:max-w-[130px]'>
            <p className='text-[16px] font-semibold mb-[1rem]'>
              Privacy & Accessibility

            </p>
            <ul className='space-y-2 text-[#000000] opacity-[.40]'>
              <li className='mb-[1rem]'>
                Privacy Policy
              </li>
              <li>
                Accessibility Statement
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
